<template>
    <div class="openSidebar">
        <div class="sidebar-logo-container flex align-cen">
            <img src="../../assets/images/head.png" alt="">
            <div class="name">HeroSim教师管理端</div>
        </div>
         <div  class="leftclass">
             <div class="menu-list">
                 <div class="rowlist flex  alighn-cen" 
            v-for="(item,index) in treedata" 
            :key = "item.id"
            :class="{current:active==index && !item.children}"  
            >
            <div v-if="!item.children" class="inls"
              @click='openchilden(index,item.name,item.children)'
            >
              <i :class="item.icon"></i>
              <span slot="title">{{item.title}}</span>
            </div>
              <div v-if="item.children" style="width:100%">
                 <el-collapse v-model="activeNames">
                   <div class="">
                     <el-collapse-item  :name="item.id">
                      <template slot="title">
                      <div class="flex align-cen">
                         <i :class="item.icon"></i>
                        {{item.title}}
                      </div>
                     </template>
                     <div class="childItem-item" 
                      v-for="childItem in item.children" 
                     :key="childItem.id"
                     :index="childItem.name"
                      @click.stop="openViews(childItem.name,childItem.title)"
                     >
                     <div  :class="{chcurrent:chative == childItem.name}">
                      {{childItem.title}}
                     </div>
                      
                     </div>
                     </el-collapse-item>
                   </div>
                 </el-collapse>
              </div>
             </div>
         </div>
    </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        businessInfo:{},
        activeNames:[],
        chative:'',
        active:'',
        titname:'',
        treedata:[
              {
                icon:'icon-al-chart-area',
                name:'/teacheManage/dashboard',
                path:'',
                title:'控制中心',
                id:'1', 
            }, {
                icon:'icon-al-application',
                name:'/teacheManage/appControl',
                path:'',
                title:'我的应用',
                id:'2', 
                 children:[{
                   icon:'',
                    name:'/teacheManage/appControl',
                    path:'',
                    title:'我的应用',
                    id:'21', 
                    parentId:'2',
                 },{
                   icon:'',
                    name:'/teacheManage/appLog',
                    path:'',
                    title:'应用日志',
                    id:'22', 
                    parentId:'2',
                 }
                 ]
            },
              {
                icon:'icon-al-folder-fill',
                name:'/teacheManage/enTestPaper',
                path:'',
                title:'试卷管理',
                id:'3',
                 children:[
                  {
                   icon:'',
                    name:'/teacheManage/enTestPaper',
                    path:'',
                    title:'试卷列表',
                    id:'31', 
                    parentId:'3',
                 },
                  {
                   icon:'',
                    name:'/teacheManage/enTestPaperClass',
                    path:'',
                    title:'试卷分类',
                    id:'32', 
                    parentId:'3',
                 },
                 ]
            },
               {
                icon:'icon-al-fileplus-fill',
                name:'/teacheManage/questionClass',
                path:'',
                title:'题库管理',
                id:'4', 
                 children:[
                  {
                   icon:'',
                    name:'/teacheManage/questionList',
                    path:'',
                    title:'题目列表',
                    id:'41', 
                    parentId:'4',
                 },
                  {
                   icon:'',
                    name:'/teacheManage/questionClass',
                    path:'',
                    title:'题目分类',
                    id:'42', 
                    parentId:'4',
                 },
                  {
                   icon:'',
                    name:'/teacheManage/questionImport',
                    path:'',
                    title:'批量导入',
                    id:'43', 
                    parentId:'4',
                 }
                 ]
               },
               {
                icon:'icon-al-folder-fill',
                name:'/teacheManage/enSimulationPaper',
                path:'',
                title:'仿真试卷',
                id:'5', 
               },
            {
                icon:'icon-al-user-group-fill',
                name:'/teacheManage/member',
                path:'',
                title:'成员管理',
                id:'6', 
                 children:[{
                    icon:'',
                    name:'/teacheManage/member',
                    path:'',
                    title:'成员列表',
                    id:'60', 
                    parentId:'6',
                 },{
                    icon:'',
                    name:'/teacheManage/role',
                    path:'',
                    title:'角色列表',
                    id:'61', 
                    parentId:'6',
                 },
                 {
                   icon:'',
                    name:'/teacheManage/studentClass',
                    path:'',
                    title:'学员分类',
                    id:'62', 
                    parentId:'6', 
                 },{
                   icon:'',
                    name:'/teacheManage/studentList',
                    path:'',
                    title:'学员列表',
                    id:'63', 
                    parentId:'6',  
                 }]
            },
            
        ]
        }
    },
     watch: { 
       $route() {
          if(this.$route){
        this.chative = this.$route.meta.parent.isShow ? this.$route.meta.parent.path : this.$route.path
        this.active = this.$route.meta.index
        this.activeNames.push(String( this.$route.meta.index + 1))
        this.activeNames = [...new Set(this.activeNames)]

         }
    }
  },
    created () {
 this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
    let that = this
    this.chative = this.$route.meta.parent.isShow ? this.$route.meta.parent.path : this.$route.path
    this.active = this.$route.meta.index
    this.activeNames.push(String( this.$route.meta.index + 1))
    },
    methods: {
        handleChange(val){
    },
    openchilden(i,url,child){
      this.$router.push(url)
      this.active = i
     this.chative = url
    },
    // 打开页面
    openViews(url,child){
      this.active = -1
      this.chative = url
      this.$router.push(url)
    },
    },
}
</script>
<style lang="scss" scoped>
.openSidebar{
    position: relative;
     height: 100%;
     width: 100%;
     overflow: hidden;
     .sidebar-logo-container{
            position: relative;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #2b2f3a;
    text-align: center;
    overflow: hidden;
    justify-content: center;
    img{
        width: 30px;
    }
    .name{
        padding-left: 10px;
            color: #fff;
    font-weight: 600;
    line-height: 56px;
    font-size: 14px;
    font-family: Avenir,Helvetica Neue,Arial,Helvetica,sans-serif;
    vertical-align: middle;
    }
     }
     .leftclass{
        width: 100%;
        height: calc(100vh - 56px);
        overflow-x: hidden;
        overflow-y: auto;
        .rowlist{
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  color: #bfcbd9;
  padding-left: 32px;
  i{
    padding-right: 20px;
    font-size: 18px;
  }
  .inls{
      height: 60px;
  line-height: 60px;
  width: 100%;
  padding-right: 80px;
  }
  
}
 .rowlist:hover{
    background:#001528;
 }
  .current{
    color: #409eff;
    position: relative;
  }
      .chcurrent{
    color: #409eff;
    position: relative;
    }
//    .current::before{
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 3px;
//     height: 100%;
//     background-color: #2893f1;
//     border-radius: 0 4px 4px 0;
//    };
//    .chcurrent::before{
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 3px;
//     height: 100%;
//     background-color: #2893f1;
//     border-radius: 0 4px 4px 0;
//    };
     }
/*滚动条样式*/
.leftclass::-webkit-scrollbar {
    width: 4px;    
}
.leftclass::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: rgba(0,0,0,0.2);
}
.leftclass::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 0;
    background: rgba(255,255,255,0.1);

}
el-menu {
    background: none !important;
    border: none !important;

}
.el-menu--collapse{
    width: 54px;
}
.el-menu-item.is-active{
        color: #409EFF !important;
}
}
::v-deep{
   .el-menu-item-group__title{
    padding: 0 !important;
   }
.el-menu--vertical{
     
    color: #FFF;
}
.el-collapse{
  border: none;
  background: none;
      cursor: pointer;
          .el-collapse-item__header{
        color: #bfcbd9 !important;
        font-size: 14px;
           height: 56px;
           line-height: 56px;
           border-bottom: none;
           font-weight: 400;
           background:none;
         div{
            color: #bfcbd9 !important;
         }
      }
      .el-collapse-item__header:hover{
    background:#001528;
 }
      .childItem-item,.elsetit{
         height: 56px;
           line-height: 56px;
           font-size: 14px;
           color: #bfcbd9;
           text-align: center;
           background:#001528;
      }
      
      .el-collapse-item__content{
        color: #bfcbd9 !important;
        font-size: 14px;
        padding-bottom: 0;
      }
      .el-collapse-item__arrow{
        margin: inherit;
    margin-left: 30px;
    font-size: 12px;
      }
  .el-collapse-item__wrap{
    border: none;
    margin-left: -32px;
  }
}
}
</style>